import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
export default {
  name: "my-token",
  inject: ["reload"],
  computed: {
    ...walletVuex.mapState(["isMobile", "netId", "isWallet"]),
    ...userVuex.mapState(["token", "etherUSD", "userInfo"])
  },
  watch: {
    isWallet: {
      handler(newBool, oldBool) {
        if (!newBool) return;
        this.initSelectTab();
        this.walletWeb3Init();
      },
      deep: true
      // immediate: true,
    },

    selectTab: {
      async handler(newTab, oldTab) {
        if (newTab !== oldTab && this.isWallet) {
          if (newTab === "tokensihold") {
            this.isMyTokenLoading = true;
            this.myTokenPage.page = 1;
            await this.setMyToken();
            this.isMyTokenLoading = false;
          } else if (newTab === "launchedbyme") {
            this.isMyLaunchedLoading = true;
            this.myLaunchedPage.page = 1;
            await this.setMyLaunchedToken();
            this.isMyLaunchedLoading = false;
          } else if (newTab === "mytwitter") {
            this.isMyTwitterLoading = true;
            this.myTwitterPage.page = 1;
            await this.setMyTwitterToken();
            this.isMyTwitterLoading = false;
          }
        }
      }
    }
  },
  data() {
    const tab = [{
      label: this.$lang("Tokens I hold"),
      value: "tokensihold"
    }, {
      label: this.$lang("Launched by me"),
      value: "launchedbyme"
    }, {
      label: this.$lang("My Twitter link"),
      value: "mytwitter"
    }];
    return {
      tab,
      selectTab: "",
      isAdd: false,
      myToken: null,
      myTokenPage: {
        total: 100,
        page: 1,
        perPage: 30
      },
      isMyTokenLoading: true,
      isMyLaunchedLoading: true,
      myLaunched: null,
      myLaunchedPage: {
        total: 100,
        page: 1,
        perPage: 30
      },
      isMyTwitterLoading: true,
      myTwitter: null,
      myTwitterPage: {
        total: 100,
        page: 1,
        perPage: 30
      },
      isTwitterAuthorizeLoading: false
    };
  },
  methods: {
    ...walletVuex.mapActions(["doConnect"]),
    ...userVuex.mapActions(["getMyToken", "getMyLaunchToken", "getMyTwiiter"]),
    initSelectTab() {
      const tab = this.$route.query.tab;
      if (!tab) {
        return;
      }
      this.selectTab = tab;
    },
    onSkip() {
      this.$router.push("/");
    },
    async walletWeb3Init() {
      await this.noWalletWeb3Init();
    },
    async noWalletWeb3Init() {
      if (this.selectTab === "tokensihold") {
        await this.setMyToken();
      } else if (this.selectTab === "launchedbyme") {
        await this.setMyLaunchedToken();
      } else if (this.selectTab === "mytwitter") {
        await this.setMyTwitterToken();
      }
    },
    async setMyToken() {
      let page = this.myTokenPage.page;
      let perPage = this.myTokenPage.perPage;
      const res = await this.getMyToken({
        wallet: this.web3Wallet.address,
        perPage,
        page
      });
      if (!res) {
        this.isMyTokenLoading = false;
        return;
      }
      this.isMyTokenLoading = false;
      const list = res.items.map(item => {
        return {
          ...item,
          marketCap: item.pool_price ? _v.fmt_pre(_v.bigNumber(_v.fmt_sc(item.pool_price)).times(item.total_supply).times(this.etherUSD), 0) : 0,
          //市值
          tradingVolume: _v.fmt_pre(_v.fmt_sc(item.volume)),
          //交易量
          priceGain24h: _v.fmt_pre(item.diff * 100, 2),
          //24小时价格上涨百分比
          sold_token: item.pool_ether !== null ? this.bigNumber(item.pool_ether).div(this.maxEther).times(100).toFixed(18) : 0 //当前卖出代币占比
        };
      });

      this.myTokenPage.total = res.total;
      this.myToken = list;
    },
    async setMyLaunchedToken() {
      let page = this.myLaunchedPage.page;
      let perPage = this.myLaunchedPage.perPage;
      const res = await this.getMyLaunchToken({
        wallet: this.web3Wallet.address,
        perPage,
        page
      });
      if (!res) {
        this.isMyLaunchedLoading = false;
        return;
      }
      const list = res.items.map(item => {
        return {
          ...item,
          marketCap: _v.fmt_pre(_v.bigNumber(item.pool_price).times(item.total_supply).times(this.etherUSD), 0),
          //市值
          tradingVolume: _v.fmt_pre(_v.fmt_sc(item.volume)),
          //交易量
          priceGain24h: _v.fmt_pre(item.diff * 100, 2),
          //24小时价格上涨百分比
          sold_token: item.pool_ether !== null ? this.bigNumber(item.pool_ether).div(this.maxEther).times(100).toFixed(18) : 0 //当前卖出代币占比
        };
      });

      this.isMyLaunchedLoading = false;
      this.myLaunchedPage.total = res.total;
      this.myLaunched = list;
    },
    async setMyTwitterToken() {
      if (!this.userInfo.twitter) {
        return;
      }
      let page = this.myTwitterPage.page;
      let perPage = this.myTwitterPage.perPage;
      const res = await this.getMyTwiiter({
        wallet: this.web3Wallet.address,
        perPage,
        page
      });
      if (!res) {
        this.isMyTwitterLoading = false;
        return;
      }
      const list = res.items.map(item => {
        return {
          ...item,
          marketCap: _v.fmt_pre(_v.bigNumber(item.pool_price).times(item.total_supply).times(this.etherUSD), 0),
          //市值
          tradingVolume: _v.fmt_pre(_v.fmt_sc(item.volume)),
          //交易量
          priceGain24h: _v.fmt_pre(item.diff * 100, 2),
          //24小时价格上涨百分比
          sold_token: item.pool_ether !== null ? this.bigNumber(item.pool_ether).div(this.maxEther).times(100).toFixed(18) : 0 //当前卖出代币占比
        };
      });

      this.isMyTwitterLoading = false;
      this.myTwitterPage.total = res.total;
      this.myTwitter = list;
    },
    onAdd() {
      this.$router.push("/launch");
    },
    onMyTokenPage(page) {
      this.myTokenPage.page = page;
      this.setMyToken();
    },
    onMyLaunchedPage(page) {
      this.myLaunchedPage.page = page;
      this.setMyLaunchedToken();
    },
    onMyTwitterPage(page) {
      this.myTwitterPage.page = page;
      this.setMyTwitterToken();
    },
    async getTwitterAuthUrl() {
      try {
        if (this.isTwitterAuthorizeLoading) return;
        this.isTwitterAuthorizeLoading = true;
        const signStr = "Get Twitter Auth Url";
        const signature = await this.web3Wallet.signMessage(signStr);
        if (!signature) {
          this.isTwitterAuthorizeLoading = false;
          return;
        }
        const res = await this.$http.post("auth/twitter/authurl", {
          address: this.web3Wallet.address,
          signature: signature,
          signStr: signStr,
          callback: this.web3metadata.url + "twitter/callback"
        });
        this.isTwitterAuthorizeLoading = false;
        if (res.code == 0) {
          localStorage.setItem("twitter_callback_path", location.href + "?tab=mytwitter");
          // open(res.data.url, "target");
          window.location.href = res.data.url;
        } else {
          // this.error = res.message;
          this.$toasted.error(res.message);
        }
      } catch (err) {
        // this.error = err.message || "获取失败";
        this.$toasted.error(err.message || "Authorization failed");
      }
    }
  }
};